import { Box, FormControl, FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import React, { useContext, useState } from "react";
import { UserTypeContext } from "../../context/userStatus";
import useWidth from "../../utils/useWidth";
import palette from "../../theme/palette";
import { pxToRem } from "../../theme/typography";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@material-ui/core";
import CommonTypo from "../../components/CommonTypo";
import NewButton from "../../components/NewButton";
import { SnackBarCompV2 } from "../../components/snackBar";
import { userService } from "../../services/auth";

const RootStyle = styled("div")(({ theme }) => ({
    padding: "0px",
    display: 'flex',
    alignItems: "flex-start",
    flexDirection: 'column',
    gap: '27px',
    borderRadius: "12px",
    "@media (max-width: 786px)": {
        gap: "24px !important",
        overflowY: "auto",
        overflowX: "hidden"
    },
}));
const useStyles = makeStyles((theme) => ({
    registrationHeading: {
        color: palette.primary.light,
        fontSize: '24px !important',
        fontWeight: 400,
        lineHeight: '175% !important',
    },
    registrationHeadingInner: {
        color: `${palette.primary.light} !important`,
        fontSize: '20px !important',
        fontWeight: 400,
        lineHeight: '175% !important',
    },
    miHeight: {
        minHeight: `calc(100vh - 30%)`
    }
}))
const PageWithAccountDeletedWidget = ({ Component }) => {
    const { state: IUserTypeState } =
        useContext(UserTypeContext);
    const classes = useStyles()
    const width = useWidth()
    const isMobile = width < 768
    const [selectedPlan, setSelectedPlan] = useState(null)
    const [showSnakbar, setShowSnakbar] = useState(false);
    const [snakbarMsg, setSnakbarMsg] = useState("");
    const [msgType, setMsgType] = useState("");
    const closeWithSelectedPlan = () => {
        if (!selectedPlan) {
            setShowSnakbar(true)
            setMsgType("error")
            setSnakbarMsg("Please select a plan")
            return
        }
        const foundPlan = IUserTypeState.planProducts.find(it => {
            return it.price.id === selectedPlan
        })
        if (foundPlan) {
            createCheckoutLink(foundPlan)
        }
    }
    const token = localStorage.getItem("userDetails")
    const createCheckoutLink = (planInfo) => {
        userService.createCheckout({
            price: planInfo.price.id
        }, token).then(data => {
            console.log("data", data)
            if (data.data) {
                window.open(data.data.url)
            }
        }).catch(err => {
            console.log("err", err);
        })
    }
    return IUserTypeState.accountBlocked ? (
        <Grid
            container
            columns={16}
            className={width <= 768 ? "bgUserIdentification" : "bgUserIdentificationNew"}
            sx={{
                backgroundColor: palette.secondary.light,
                position: "absolute",
                zIndex: 99999,
                width: "100%",
                height: "100vh",
            }}
        >
            <Box
                sx={{
                    display: 'flex !important',
                    padding: '0px',
                    flexDirection: 'column !important',
                    alignItems: 'flex-start !important',
                    gap: "27px !important",
                    position: "relative",
                    opacity: "100%",
                    zIndex: 1,
                    width: "100%",
                    height: "100vh",
                    "@media (max-width: 786px)": {
                        position: "relative",
                        display: 'flex !important',
                        alignItems: "center",
                        gap: "24px !important",
                        justifyContent: "center",
                        fontSize: `${pxToRem(16)} !important`,
                        width: "calc(100vw) !important",
                        padding: '0px !important',
                        borderRadius: "12px",
                        maxHeight: "calc(100vh)",
                        height: "100vh",
                    },
                }}
            >
                <Grid
                    item
                    sx={{
                        display: "flex",
                        alignItems:
                            width <= 768 ? "flex-start" : "center",
                        justifyContent: "center",
                        width: "100%",
                        height: "calc(100vh)",
                        overflowY: "auto",
                        overflowX: "hidden",
                        borderRadius: "12px",
                        "@media (max-width: 786px)": {
                            width: "312px",
                            margin: "0px auto",
                            height: "calc(100vh - 10%)",
                            overflowY: "auto"
                        },
                    }}
                    className="leftside-menu outcome-screen hide-scrollbar"
                >
                    <RootStyle
                        sx={{
                            background: `rgba(255, 255, 255, 1) !important`,
                            minWidth: isMobile ? "312px" : "628px",
                            maxWidth: isMobile ? "312px" : "628px",
                            minHeight: isMobile ? `calc(100vh - 30%)` : "calc(100vh - 5%)",
                            maxHeight: isMobile ? `calc(100vh - 20%)` : "calc(100vh - 5%)",
                            overflowY: isMobile ? "hidden" : "auto",
                        }}
                        className="hide-scrollbar"
                    >
                        <Box sx={{
                            width: "100%",
                            borderRadius: "12px 12px 0px 0px"
                        }}>
                            <img src={"paymentfailed.png"} alt="payment-logo" style={isMobile ? {
                                width: "100%",
                                height: "156px",
                                objectFit: "cover",
                                borderRadius: "12px 12px 0px 0px",
                                objectPosition: "center 75%"
                            } : {
                                width: "100%",
                                height: "314px",
                                objectFit: "cover",
                                borderRadius: "12px 12px 0px 0px",
                                objectPosition: "center 75%"
                            }} />
                        </Box>
                        <Box display={"flex"} flexDirection={"column"} gap={isMobile ? "8px" : "16px"} padding={"0px 32px"}>
                            <CommonTypo size={isMobile ? 18 : 24} lineHeight={isMobile ? 20 : 24} color="var(--color-text-primary)" fontWeight={isMobile ? 600 : 700}>Account data deleted</CommonTypo>
                            <CommonTypo size={isMobile ? 12 : 16} lineHeight={isMobile ? 20 : 16} color="var(--color-text-secondary)" fontWeight={400} extraSx={{
                                letterSpacing: isMobile ? '0%' : "-1%",
                            }}>Your account was restricted, and the time to subscribe has passed. As a result, your data has been removed to protect your privacy. Just like deleting files from a hard drive, data recovery is complex, costly, and not always successful. If you’re still within a grace period (30 days) and would like us to attempt a manual recovery, please contact Support. We cannot guarantee a full restoration, and additional fees apply.</CommonTypo>
                        </Box>
                        <Box display={"flex"} flexDirection={"column"} gap={"8px"} padding={"0px 32px"} sx={{
                            marginTop: "0px",
                            width: isMobile ? "312px" : "100%",
                            height: "auto"
                        }}>
                            <Box display={"flex"} flexDirection={"column"} alignItems={"center"} alignSelf={"stretch"} borderRadius={"12px"} gap={"8px"} border={"1px solid var(--color-border)"} padding={"16px"}>
                                <CommonTypo size={isMobile ? 12 : 16} fontWeight={400} lineHeight={isMobile ? 20 : 16} color="var(--color-text-primary)">Time until your data can be recovered:</CommonTypo>
                                <CommonTypo size={isMobile ? 18 : 32} fontWeight={600} lineHeight={isMobile ? 20 : 36} color="var(--color-text-primary)" >You have 30 days to request a <br />data-recovery attempt</CommonTypo>
                            </Box>
                        </Box>
                        <Box display={"flex"} flexDirection={"column"} gap={"8px"} padding={"0px 32px"} sx={{
                            marginTop: "0px",
                            width: "100%",
                            height: "auto"
                        }}>
                            <CommonTypo size={16} fontWeight={isMobile ? 600 : 400} lineHeight={18} color="var(--color-text-primary)">{"Subscribe to save your progress and data"}</CommonTypo>
                            <FormControl sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                alignSelf: 'stretch',
                                justifyContent: "center",
                                width: "100%",
                            }}>
                                {<RadioGroup
                                    className="radio-wrapper"
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    name="radio-buttons-group"
                                    onChange={(e) => setSelectedPlan(e.target.value)}
                                    value={selectedPlan || ""}
                                    sx={true ? {
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        gap: '8px',
                                        alignSelf: 'stretch',
                                        padding: "0px",
                                        width: "100%",
                                        marginBottom: 0,
                                        flexWrap: "wrap"
                                    } : {
                                        width: "100%",
                                        marginBottom: 0
                                    }}
                                >
                                    {IUserTypeState.planProducts.map(({ name, price: { id, currency, unit_amount } }) => {
                                        return <FormControlLabel value={id} control={<Radio sx={{
                                            "&.MuiRadio-root.Mui-checked": {
                                                color: "var(--color-text-primary)"
                                            },
                                            "&.MuiRadio-root": {
                                                padding: "0px"
                                            }
                                        }} />} label={<Box display={"flex"} flexDirection={"column"} gap={"4px"}>
                                            <Box display={"flex"} gap={"9px"} alignItems={"center"}>
                                                <CommonTypo size={isMobile ? 14 : 16} fontWeight={600} lineHeight={isMobile ? 16 : 19.2} color="var(--color-text-primary)">{name}</CommonTypo>
                                                {name === "Yearly" && (
                                                    <Box display={"flex"} gap={"8px"} alignItems={"center"} height={"18px"} padding={"4px"} sx={{
                                                        borderRadius: "6px",
                                                        background: "var(--color-new-main)"
                                                    }}>
                                                        <CommonTypo size={10} fontWeight={600} lineHeight={10} color="var(--color-text-primary)">{"2 -month discount"}</CommonTypo>
                                                    </Box>
                                                )}
                                            </Box>
                                            {name === "Yearly" && (
                                                <Box display={"flex"} gap={"4px"} alignItems={"center"}>
                                                    <CommonTypo size={14} fontWeight={isMobile ? 400 : 500} lineHeight={22.4} color="var(--color-text-primary)">${unit_amount / 100}/year</CommonTypo>
                                                    <CommonTypo size={14} fontWeight={400} lineHeight={22.4} color="var(--color-text-secondary)" extraSx={{
                                                        textDecoration: "line-through"
                                                    }}>$119.99/year</CommonTypo>
                                                </Box>
                                            )}
                                            {name === "Monthly" && (
                                                <Box display={"flex"} gap={"4px"} alignItems={"center"}>
                                                    <CommonTypo size={14} fontWeight={isMobile ? 400 : 500} lineHeight={22.4} color="var(--color-text-primary)">${unit_amount / 100}/month</CommonTypo>
                                                </Box>
                                            )}
                                            {name === "Daily Plan" && (
                                                <Box display={"flex"} gap={"4px"} alignItems={"center"}>
                                                    <CommonTypo size={14} fontWeight={isMobile ? 400 : 500} lineHeight={22.4} color="var(--color-text-primary)">${unit_amount / 100}/day</CommonTypo>
                                                </Box>
                                            )}
                                        </Box>} sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '16px',
                                            width: "49%",
                                            height: "78px",
                                            border: "1px solid var(--color-border)",
                                            borderRadius: '12px',
                                            padding: "16px",
                                            background: '#FFF',
                                            marginRight: 0,
                                            marginLeft: 0,
                                            "& .MuiTypography-root": {
                                                color: "var(--color-text-primary) !important",
                                            },
                                            "@media (max-width: 786px)": {
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '16px',
                                                width: "100%",
                                                height: "60px",
                                                alignSelf: "stretch",
                                                border: "1px solid var(--color-border)",
                                                borderRadius: '12px',
                                                padding: "8px 16px",
                                                background: '#FFF',
                                                marginRight: 0,
                                                marginLeft: 0,
                                                "& .MuiTypography-root": {
                                                    color: "var(--color-text-primary) !important",
                                                },
                                            },
                                        }} />
                                    })}


                                </RadioGroup>}
                            </FormControl>
                        </Box>
                        <Box display={"flex"} flexDirection={"column"} gap={isMobile ? "8px" : "24px"} padding={isMobile ? "0px 24px" : "0px 32px"} sx={{
                            marginTop: "0px",
                            width: "100%",
                            marginBottom: "32px"
                        }}>
                            <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
                                <NewButton
                                    type="button"
                                    isDisabled={false}
                                    boxSx={{
                                        display: 'flex',
                                        alignSelf: "stretch",
                                        width: "312px",
                                        justifyContent: "center",
                                    }}
                                    extraSx={{
                                        display: 'flex',
                                        alignSelf: "stretch",
                                        width: isMobile ? "100%" : "312px",
                                        background: "var(--color-new-main)",
                                        height: "40px",
                                        "&:hover": {
                                            background: "var(--color-new-main)",
                                        }
                                    }}
                                    typographySx={{
                                        "&.MuiTypography-root": {
                                            fontSize: `${pxToRem(16)} !important`,
                                            lineHeight: "100% !important",
                                            fontWeight: 600,
                                            color: "var(--color-text-primary)",
                                            "@media  (max-width: 786px) and (min-width: 100px)": {
                                                fontSize: `${pxToRem(16)} !important`,
                                                lineHeight: "100% !important",
                                                fontWeight: 600,
                                                color: "var(--color-text-primary)"
                                            },
                                        },
                                    }}
                                    buttonText={<Box display={"flex"} alignItems={"center"} gap={"4px"}>
                                        <CommonTypo color="var(--color-text-primary)" fontWeight={600} size={16} lineHeight={16}>Subscribe</CommonTypo>
                                    </Box>}
                                    onClick={closeWithSelectedPlan}
                                    fontSize="16px"
                                />
                            </Box>
                        </Box>
                    </RootStyle>
                </Grid>
            </Box>
            <SnackBarCompV2
                showSnakbar={showSnakbar}
                handleCloseSnakbar={() => {
                    setShowSnakbar(false);
                }}

                snakbarMsg={<CommonTypo size={16} fontWeight={600} lineHeight={19.2} color="var(--color-text-primary)">{snakbarMsg}</CommonTypo>}
                type={msgType ? msgType : "success"}
                alertSx={{
                    background: msgType === "error" ? "#FF5555" : "var(--color-new-main)",
                    boxShadow: "0px 4px 8px 0px #0000001A",
                    padding: "16px",
                    borderRadius: "12px",
                    height: "52px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    zIndex: 12,
                    opacity: "100%",
                    "& .MuiAlert-icon": {
                        marginRight: "0px"
                    }
                }}
                icon={msgType === "success" ? <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.7883 7.46172C13.8757 7.54882 13.945 7.65231 13.9923 7.76626C14.0397 7.88022 14.064 8.00239 14.064 8.12578C14.064 8.24917 14.0397 8.37134 13.9923 8.4853C13.945 8.59925 13.8757 8.70275 13.7883 8.78984L9.41328 13.1648C9.32619 13.2522 9.22269 13.3216 9.10874 13.3689C8.99478 13.4162 8.87261 13.4406 8.74922 13.4406C8.62583 13.4406 8.50366 13.4162 8.3897 13.3689C8.27575 13.3216 8.17226 13.2522 8.08516 13.1648L6.21016 11.2898C6.12295 11.2026 6.05378 11.0991 6.00658 10.9852C5.95939 10.8712 5.9351 10.7491 5.9351 10.6258C5.9351 10.5025 5.95939 10.3803 6.00658 10.2664C6.05378 10.1525 6.12295 10.0489 6.21016 9.96172C6.29737 9.87451 6.40089 9.80534 6.51483 9.75814C6.62877 9.71095 6.75089 9.68666 6.87422 9.68666C6.99755 9.68666 7.11967 9.71095 7.23361 9.75814C7.34755 9.80534 7.45108 9.87451 7.53828 9.96172L8.75 11.1719L12.4617 7.45938C12.5489 7.37236 12.6525 7.3034 12.7664 7.25642C12.8803 7.20944 13.0023 7.18537 13.1255 7.18559C13.2487 7.18581 13.3706 7.21031 13.4844 7.25769C13.5981 7.30507 13.7014 7.3744 13.7883 7.46172ZM18.4375 10C18.4375 11.6688 17.9427 13.3001 17.0155 14.6876C16.0884 16.0752 14.7706 17.1566 13.2289 17.7952C11.6871 18.4338 9.99064 18.6009 8.35393 18.2754C6.71721 17.9498 5.2138 17.1462 4.03379 15.9662C2.85379 14.7862 2.05019 13.2828 1.72463 11.6461C1.39907 10.0094 1.56616 8.31286 2.20477 6.77111C2.84338 5.22936 3.92484 3.9116 5.31238 2.98448C6.69992 2.05735 8.33122 1.5625 10 1.5625C12.237 1.56498 14.3817 2.45473 15.9635 4.03653C17.5453 5.61833 18.435 7.763 18.4375 10ZM16.5625 10C16.5625 8.70206 16.1776 7.43327 15.4565 6.35407C14.7354 5.27487 13.7105 4.43374 12.5114 3.93704C11.3122 3.44034 9.99272 3.31038 8.71972 3.5636C7.44672 3.81681 6.2774 4.44183 5.35962 5.35961C4.44183 6.27739 3.81682 7.44672 3.5636 8.71972C3.31038 9.99272 3.44034 11.3122 3.93704 12.5114C4.43374 13.7105 5.27488 14.7354 6.35407 15.4565C7.43327 16.1776 8.70206 16.5625 10 16.5625C11.7399 16.5606 13.408 15.8686 14.6383 14.6383C15.8686 13.408 16.5606 11.7399 16.5625 10Z" fill="#3E4240" />
                </svg> : null
                }
            />
        </Grid>
    ) : <Component />
}

export default PageWithAccountDeletedWidget